/** @jsx jsx */
import { jsx, Box } from 'theme-ui'
import { Link,navigate } from 'gatsby'
import React from 'react'

const LpHeader = () => {

  const handleButtonClick = () => {
    if (typeof window !== 'undefined' && window.location.pathname === '/lp/for-company/') {
      navigate('/matching')
      return
    }

    navigate('/contact-engineer')
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        backgroundColor: '#ffffff',
        width: '100%',
        margin: '0 auto',
        justifyContent: 'space-between',
        boxShadow: '0 5px 10px 0 rgba(0,0,0,.15)',
      }}
    >
      <Box
        sx={{
          width: '100%',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: ['0.5rem 16px', '0.5rem 24px', '0.5rem 32px'],
          height: ['60px', '80px'],
        }}
      >
        <Link to="/" aria-label="ホームへ" sx={{ display: 'block' }}>
          <img
            src="/new_logo_color.webp"
            alt="engibiz logo"
            sx={{
              width: ['130px', '160px'],
              maxWidth: '250px',
            }}
          />
        </Link>
        <button
            type="button"
            onClick={handleButtonClick}
            sx={{
              border: 'none',
              background: '#20416d',
              color: '#fff',
              cursor: 'pointer',
              borderRadius: '999px',
              padding: '0.5rem 0.9rem',
              textAlign: 'center',
              boxShadow: '0 5px 10px rgba(0,0,0,0.12)',
              fontWeight: 700,
              fontSize: '0.95rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              whiteSpace: 'nowrap',
            }}
          >
            無料で始める
          </button>
      </Box>
    </Box>
  )
};

export default LpHeader;